import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../shared/axiosInstance";

const TargetSignUp = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // ✅ Parse query parameters from URL
    const queryParams = new URLSearchParams(location.search);
    const prefilledEmail = queryParams.get("email") || "";
    const prefilledFirstName = queryParams.get("firstName") || "";
    const prefilledLastName = queryParams.get("lastName") || "";

    // ✅ State for form
    const [formData, setFormData] = useState({
        email: prefilledEmail,
        firstName: prefilledFirstName,
        lastName: prefilledLastName,
        password: "",
    });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // ✅ Prefill the form only if values exist
        setFormData((prev) => ({
            ...prev,
            email: prefilledEmail,
            firstName: prefilledFirstName,
            lastName: prefilledLastName
        }));
    }, [prefilledEmail, prefilledFirstName, prefilledLastName]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        if (!formData.password.trim()) {
            setError("Password is required.");
            setLoading(false);
            return;
        }

        try {
            await api.post("/auth/register-target", formData);
            navigate("/assessment"); // ✅ Redirect directly to assessment
        } catch (err) {
            const msg = err.response?.data?.message || err.response?.data?.error;
            if (msg === "User already exists" || msg === "User with this email already exists.") {
                setError(
                    <>
                        You already have an account. Please <a href="/signin" className="text-orange underline">sign in</a>.
                    </>
                );
            } else {
                setError(msg || "An error occurred. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-darkblue text-lightgray relative">
            <div className="w-full max-w-md bg-bluegray shadow-lg rounded-lg p-6">
                <h1 className="text-3xl font-bold text-center text-orange mb-6">
                    Confirm Your Target Status
                </h1>
                {error && <div className="bg-red text-white text-sm p-2 rounded mb-4">{error}</div>}

                <form onSubmit={handleSubmit} className="space-y-4">
                    {/* Email */}
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium mb-1">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 rounded bg-deepblue text-lightgray border border-lightblue focus:outline-none focus:ring-2 focus:ring-orange"
                        />
                    </div>

                    {/* First Name */}
                    <div>
                        <label htmlFor="firstName" className="block text-sm font-medium mb-1">First Name</label>
                        <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 rounded bg-deepblue text-lightgray border border-lightblue focus:outline-none focus:ring-2 focus:ring-orange"
                        />
                    </div>

                    {/* Last Name */}
                    <div>
                        <label htmlFor="lastName" className="block text-sm font-medium mb-1">Last Name</label>
                        <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 rounded bg-deepblue text-lightgray border border-lightblue focus:outline-none focus:ring-2 focus:ring-orange"
                        />
                    </div>

                    {/* Password */}
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium mb-1">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 rounded bg-deepblue text-lightgray border border-lightblue focus:outline-none focus:ring-2 focus:ring-orange"
                        />
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="w-full py-2 px-4 bg-orange hover:bg-deeporange text-white font-medium rounded transition duration-300"
                        disabled={loading}
                    >
                        {loading ? "Processing..." : "Continue to Assessment"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default TargetSignUp;
